import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const HeartFilled = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M21 4C18.7 4 16.925 5.025 16 5.7C15.075 5.025 13.3 4 11 4C7.138 4 4 7.138 4 11C4 14.938 6 19.113 9.775 23.063C12.575 25.988 15.35 27.763 15.463 27.838C15.625 27.938 15.813 28.001 16 28.001C16.187 28.001 16.375 27.951 16.538 27.838C16.651 27.763 19.425 25.988 22.226 23.063C26.001 19.113 28.001 14.938 28.001 11C28.001 7.138 24.863 4 21 4Z" />
	</svg>
);

export default HeartFilled;
